import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FONT_FAMILY } from 'utils/Constants'

export const Price = styled.span`
  display: flex;
  font-size: 14px;
  font-weight: ${({ isOnSale }) => (isOnSale ? '400' : '700')};
  justify-content: center;
  text-decoration: ${({ isOnSale }) => (isOnSale ? 'line-through' : 'none')};
`

export const Badge = styled.span`
  background-color: #00b182;
  border-radius: 8px;
  color: #fff;
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  height: 16px;
  line-height: 16px;
  margin-right: 3px;
  padding-left: 6px;
  padding-right: 6px;
`
export const Features = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  & > li {
    color: ${({ theme }) => theme.colors.textColor};
    font-size: 14px;
    margin-bottom: 10px;
    padding-left: 22px;
    position: relative;
  }
`
export const FeatureHeading = styled.h4`
  color: ${({ theme }) => theme.colors.textColor};
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 22px;
`

export const CheckMark = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.inverseColor};
  position: absolute;
  top: 1px;
  left: 0;
`

export const Star = styled(FontAwesomeIcon)`
  color: #dba900;
  position: absolute;
  top: 0;
  left: 0;
`
export const CouponInfo = styled.span`
  color: ${({ theme }) => theme.colors.textColor};
  display: flex;
  font-size: 14px;
  justify-content: center;
  text-align: center;
`

export const InfoIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.inverseColor};
  margin-right: 3px;
`

export const BasicOption = styled.button`
  background: transparent;
  box-shadow: 0 0 0 transparent;
  border: 0 solid transparent;
  color: ${({ theme }) => theme.colors.inverseColor};
  font-size: 14px;
  font-family: ${FONT_FAMILY.PROXIMA_NOVA};
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-shadow: 0 0 0 transparent;

  &:hover {
    background: transparent;
    box-shadow: 0 0 0 transparent;
    border: 0 solid transparent;
    cursor: pointer;
    text-shadow: 0 0 0 transparent;
    text-decoration: underline;
  }
`
